import React from 'react';
import { Select } from 'antd';

const CustomSelect = ({ state, setState, options, defaultValue }) => {
  const handleSelect = (value) => {
    setState(value);
  };

  return (
    <Select
      value={state}
      style={{ width: 200 }}
      onChange={handleSelect}
      defaultValue={defaultValue}
      options={options}
    />
  );
};

export default CustomSelect;